import React, { useEffect } from "react";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import { useLocation } from "react-router-dom";

const LearnAboutPOSP = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when pathname changes
  }, [pathname]);

  const cardData = [
    {
      id: 1,
      title: "Free Training for Young Adults",
      description:
        "Acuvisor offers comprehensive training at no cost for individuals aged 18+. This training covers both Life and Non-Life insurance.",
    },
    {
      id: 2,
      title: "Welcome to Acuvisor's e-Learning Centre",
      description:
        "Our e-Learning Centre is designed to guide you through the process efficiently. The training modules align with the IRDAI Model Syllabus and include a unique module on 'How to Do the Business', equipping you with practical knowledge to thrive as a POSP.",
    },
    {
      id: 3,
      title: "Free Certification",
      description:
        "After completing the training, agents receive certification to sell Life and Non-Life insurance policies at no extra cost.",
    },
    {
      id: 4,
      title: "Cutting-Edge Technology",
      description:
        "Acuvisor equips POSPs with advanced tech tools, ensuring they stay connected with customers and manage their tasks effectively.",
    },
    {
      id: 5,
      title: "Simplified Lead Management",
      description:
        "Our intuitive platform helps POSPs manage leads and schedule client meetings seamlessly.",
    },
    {
      id: 6,
      title: "Personalized Recommendations",
      description:
        "Utilize our Human Life Value (HLV) calculator to understand customer needs and recommend suitable policies.",
    },
    {
      id: 7,
      title: "Flexible Earnings",
      description:
        "POSPs set their own schedules, manage clients independently, and earn commission on each successful sale.",
    },
    {
      id: 8,
      title: "Continuous Support",
      description:
        "Acuvisor provides ongoing training and resources to help agents succeed and maintain strong customer relationships.",
    },
  ];

  return (
    <div>
      <Navbar />
      <div className="pt-24 lg:px-20 md:px-10 sm:px-3 ">
        <div className="flex justify-center items-center. w-full h-sc.reen ">
          <div className="w-4/6 flex justify-center content-center border-2 rounded-2xl shadow-md ">
            <div className="hidden sm:flex flex-[4] justify-end items-center">
              <img
                src="/images/b2c/pospAgent.png"
                alt="Picture of the author"
                className="p-2 w-[100%] h-auto pb-0"
              />
            </div>

            <div className="flex-[6] flex flex-col justify-center ml-8 lg:h-80 ">
              <div>
                <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-5xl">
                  Become an
                </h2>
                <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-6xl text-customBlue">
                  Insurance agent
                </h2>
              </div>
              <div className="rounded-md mt-16 mb-2">
                <a href="https://acuvisor.com/training/login">
                  <button className="bg-customBlue text-white text-lg px-3 py-2 rounded-md  w-f.ull">
                    Click Here
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* What is a POSP Insurance Agent? */}
        <div className="flex justify-center  mt-12">
          <div className="text-center">
            <div class="flex items-center justify-center my-6">
              <div class="flex-1 border-t-2 border-customBlue mx-2"></div>
              <h3 class="text-3xl font-bold text-customBlue c.ase font-sans tracking-wider">
                What is a POSP Insurance Agent?
              </h3>
              <div class="flex-1 border-t-2 border-customBlue mx-2"></div>
            </div>

            <p className="text-lg px-2">
              A POSP (Point of Sales Person) in the insurance industry is a
              trained advisor who helps customers find and purchase insurance
              policies from reliable providers. POSP agents simplify policy
              options, provide expert advice, and create a seamless buying
              process that prioritizes trust and transparency.
            </p>
          </div>
        </div>
        {/* Why Choose Acuvisor POSP Insurance? */}
        <div className="text-center mt-16">
          <div class="flex items-center justify-center my-6">
            <div class="flex-1 border-t-2 border-customBlue mx-2"></div>
            <h3 class="text-3xl font-bold text-customBlue c.ase font-sans tracking-wider">
              Why Choose Acuvisor POSP Insurance?
            </h3>
            <div class="flex-1 border-t-2 border-customBlue mx-2"></div>
          </div>
          <p className="text-lg px-2">
            At Acuvisor, our motto is "Easy to Learn, Easy to Earn",
            highlighting our commitment to making the process simple and
            rewarding for aspiring PoSP. We ensure that becoming a successful
            POSP is within reach for everyone.
          </p>
        </div>
        {/*  Benefits of Becoming an Acuvisor POSP Insurance Agent */}
        <div className="text-center mt-16 bg-slate-200">
          <h3 className="font-semibold text-3xl text-customBlue">
            Benefits of Becoming an Acuvisor POSP Insurance Agent
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 p-6 bg-gray-50">
            {cardData.map((card) => (
              <div
                key={card.id}
                className="bg-white rounded-xl shadow-md p-6 hover:shadow-2xl hover:scale-105 hover:border-customBlue border-2 transition-all duration-300 ease-out group"
              >
                <h5 className="text-lg font-semibold text-gray-800 mb-3 group-hover:text-blue-500">
                  {card.title}
                </h5>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {card.description}
                </p>
              </div>
            ))}
          </div>
        </div>
        {/* Acuvisor POSP vs. Acuvisor Agents */}
        <div className="text-center m.t-16 my-32">
          <div className="overflow-x-auto ">
            <h3 className="font-semibold text-customBlue">
              Acuvisor POSP vs. Acuvisor Agents
            </h3>
            <table className="min-w-full border-collapse border-4 border-red-400 ">
              <tbody className="">
                <tr tbody className="">
                  <td className="border border-gray-300 px-4 sm:px-2 lg:py-6 py-6  text-md text-gray-700 w-1/2">
                    Acuvisor POSPs, on the other hand, are trained and
                    IRDAI-certified, operating independently to manage leads and
                    close sales using Acuvisor’s platform. This independence
                    allows them to build their client base while leveraging
                    Acuvisor’s tools and resources for maximum efficiency.
                  </td>
                  <td className="border border-gray-300 px-4 sm:px-2 py-3 text-md text-gray-700 w-1/2">
                    Acuvisor Agents are part of Acuvisor’s sales team,
                    responsible for generating leads and sales under the
                    guidance of experienced advisors. They work within the
                    company's ecosystem and earn commissions or profit based on
                    sales.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* The Growth of the POSP Model in India */}
        <div class="flex mt-12 bg-slate-200 ">
          <div class="basis-1/4 hidden lg:block flex-shrink-0">
            <img
              src="/images/b2c/growthposp.svg"
              alt="Picture of the author"
              className="p-2 w-[100%] h-auto pb-2"
            />
          </div>

          <div class="basis-7/10 flex-grow px-4 content-center justify-center ">
            <h3 class="text-3xl font-semibold mb-2">
              The Growth of the POSP Model in India
            </h3>
            <p class="text-gray-600 text-lg">
              The Indian insurance market is on a growth trajectory, with
              current penetration at only 4%, below the global average of 7%.
              The POSP model is crucial for expanding access, especially in
              Tier-II and Tier-III cities, which contribute nearly 50% of new
              business. This model blends technology and human interaction to
              build trust and enhance customer satisfaction.
            </p>
          </div>
        </div>
        <div class="basis-7/10 flex-grow px-4 content-center justify-center bg-slate-200">
          <h3 class="text-3xl font-semibold mb-2">
            Economic Benefits and Sustainability
          </h3>
          <p class="text-gray-600 text-lg">
            POSPs earn through a structured commission system, creating
            sustainable income opportunities. With free training, ongoing
            support, and state-of-the-art technology, Acuvisor POSPs contribute
            to a robust and profitable insurance ecosystem.
          </p>
        </div>

        {/* <div class="flex mt-12 bg-sla.te-200 ">
          <div class="basis-2/3 flex-grow px-4 content-end justify-center ">
            <h4>Join the Acuvisor POSP Network</h4>
            <p>
              Start your career as an insurance POSP agent with Acuvisor.
              Embrace our "Easy to Learn, Easy to Earn" philosophy and benefit
              from unparalleled training, technology, and support to thrive in
              the industry.{" "}
              <a
                href="https://play.google.com/store/apps/details?id=com.acuvisor.android"
                className="w-full text-customBlue"
              >
                {" "}
                Download our app{" "}
              </a>{" "}
              to begin your journey and access Acuvisor's e-Learning Centre for
              free training modules and practical business insights.
            </p>
          </div>
          <div class="basis-1/3 hidden lg:block flex-shrink-0">
            <img
              src="/images/b2c/pospbanner.png"
              alt="Picture of the author"
              className="p-2 w-[100%] h-auto pb-2"
            />
          </div>
        </div> */}
        <div className="px-6 mt.-14 pb-2">
          <a href="https://acuvisor.com/training/login" className="w-full">
            <img
              src="/images/b2c/pospbanner.png"
              alt="Picture of the author"
              className="p-2 w-[35%] h-auto pb-2"
            />
          </a>
          <h4 className="text-3xl font-medium">
            Join the Acuvisor POSP Network
          </h4>
          <p>
            Start your career as an insurance POSP agent with Acuvisor. Embrace
            our "Easy to Learn, Easy to Earn" philosophy and benefit from
            unparalleled training, technology, and support to thrive in the
            industry.{" "}
            <a
              href="https://play.google.com/store/apps/details?id=com.acuvisor.android"
              className="w-full text-customBlue"
            >
              {" "}
              Download our app{" "}
            </a>{" "}
            to begin your journey and access Acuvisor's e-Learning Centre for
            free training modules and practical business insights.
          </p>

          <div className="py-8">
            <p className="mb-1 font-semibold">
              Check the{" "}
              <a
                href="https://irdai.gov.in/distribution-development/pos"
                className="w-full text-customBlue"
              >
                IRDAI Guidelines
              </a>{" "}
              for POSP requirements
            </p>
            <p className=" font-semibold">
              Read about the POSP model growth in{" "}
              <a
                href="https://www.forbesindia.com/blog/finance/taking-insurance-to-bharat-power-of-the-posp-model/"
                className="w-full text-customBlue"
              >
                Forbes India.
              </a>
            </p>
          </div>
        </div>
        <div className="px-6 mt-14 pb-2">
          <h4>Guidelines for Becoming a POSP</h4>
          <p>
            <span className="font-semibold">Eligibility:</span> Must be at least
            18 years old and have completed 10th standard.
          </p>
          <p>
            <span className="font-semibold">Training:</span> Complete 15 hours
            of training and pass a certification exam.
          </p>
          <p>
            <span className="font-semibold">Scope:</span> Sell prepackaged,
            easy-to-understand insurance products.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LearnAboutPOSP;
